import classnames from 'classnames'
import { css } from 'emotion'
import { LoanStep, Product } from 'even-ts-static'
import * as React from 'react'
import { connect } from 'react-redux'

import { createAccount, stepSelected } from 'common/actions'
import { MultiProductDispatch } from 'embed/constants'
import { Fields } from 'embed/constants/fields'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationFieldView as ApplicationField } from 'embed/components/ApplicationField'
import ApplicationSubmitButton from 'embed/components/ApplicationSubmitButton'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import Wrapper from '../Application/Stepbystep/Wrapper'
import { useCreateAccount } from './useCreateAccount'

const styles = require('./styles')
const commonStyles = require('embed/styles/application')

export interface DispatchProps {
  dispatchCreateAccount: (password: string) => Promise<string>
  backToApplication: () => void
  continueToResults: () => void
}

type Props = DispatchProps

const UnconnectedCreateAccount: React.SFC<Props> = (props) => {
  const { backToApplication, continueToResults, dispatchCreateAccount } = props
  const {
    error,
    isLoading,
    isValid,
    onBlur,
    onChange,
    onContinue,
    onKeyDown,
    password,
    shouldShowValidationStatus,
  } = useCreateAccount(dispatchCreateAccount, () => continueToResults())

  const onSkip = continueToResults
  const onBack = backToApplication

  return (
    <ThemeConsumer>
      {({ borderRadiusSmall, colorPrimary, errorStyles, fontFamilyPrimary }) => (
        <Wrapper onBack={onBack} currentStep={0} totalNumberOfSteps={0} disableCTA={true}>
          <StepTitle>Create an account to return to your results on fiona.com</StepTitle>
          <ApplicationField
            field={Fields.Password}
            fieldData={{ isValid, shouldShowValidationStatus, value: password }}
            onBlur={onBlur}
            onChange={onChange}
            onKeyDown={onKeyDown}
            placeholder="Please choose a password"
          />
          {error && <p style={errorStyles}>{error}</p>}
          <ApplicationSubmitButton fullWidth={true} loading={isLoading} isValid={isValid} onSubmit={onContinue}>
            Continue
          </ApplicationSubmitButton>
          <button
            className={classnames(
              styles.skipButton,
              css`
                color: ${colorPrimary};
                border-radius: ${borderRadiusSmall};
                font-family: ${fontFamilyPrimary};
              `,
            )}
            onClick={onSkip}
          >
            Skip
          </button>
          <div className={classnames(commonStyles.formRow, commonStyles.consentField, styles.disclaimer)}>
            <label>
              <span>
                By entering a password and selecting ‘Continue’ I agree and accept Fiona's{' '}
                <a rel="noreferrer" target="_blank" href="https://fiona.com/terms">
                  Terms of Service
                </a>
                ,{' '}
                <a rel="noreferrer" target="_blank" href="https://fiona.com/privacy">
                  Privacy Policy
                </a>{' '}
                and{' '}
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://fiona-directus-files-production.s3.amazonaws.com/directus/originals/Even+GLBA+Model+Form+Rev+8721+(3).pdf"
                >
                  GLBA Privacy Notice
                </a>
              </span>
            </label>
          </div>
        </Wrapper>
      )}
    </ThemeConsumer>
  )
}
const mapDispatchToProps = (dispatch: MultiProductDispatch): DispatchProps => ({
  dispatchCreateAccount: (password: string) => dispatch(createAccount(password)),
  continueToResults: () => dispatch(stepSelected(Product.Loan, LoanStep.Results)),
  backToApplication: () => dispatch(stepSelected(Product.Loan, LoanStep.Application)),
})

export const CreateAccount = connect(null, mapDispatchToProps)(UnconnectedCreateAccount)
